import BulletPoint from './BulletPoint';

export default BulletPoint;